export const SITE_NAME = "DDX";
export const SITE_LONG_NAME = "Differential Diagnosis Dashboard";
export const SITE_URL = "https://diagnosticdash.com/";
